import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ImSearch } from 'react-icons/im';

const Search = ({ handleClose }) => {
    const [keyword, setKeyword] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (keyword.trim()) {
            navigate(`/products/${keyword}`);
        } else {
            navigate('products');
        }
        handleClose();
    };
    return (
        <>
            <form onSubmit={handleSubmit} className='searchBlock'>
                <input
                    type='text'
                    placeholder='Search a product here...'
                    onChange={(e) => setKeyword(e.target.value)}
                />
                <button className='primary-btn' onClick={handleSubmit}>
                    <ImSearch />
                </button>
            </form>
        </>
    );
};

export default Search;
